// extracted by mini-css-extract-plugin
module.exports = {"load-time-note":"load-time-note___Uz8H8"};